import React, { useState, useRef, useEffect } from "react";
import TableCard from "./TableCard";
import MobileReservationModal from "./MobileReservationModal";

const FloorplanOverlay = ({ onClose, selectedDate, shifts, user }) => {
  const imgRef = useRef(null);
  const [currentFloor, setCurrentFloor] = useState("inside");
  const [tables, setTables] = useState([]);
  const [allTables, setAllTables] = useState([]);
  const [imgScale, setImgScale] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [selectedTable, setSelectedTable] = useState(null);

  const selectedStr = selectedDate.toLocaleDateString("en-CA");

  useEffect(() => {
    fetch(`/reservations/api/tables/?date=${selectedStr}`)
      .then(res => res.json())
      .then(data => {
        const all = data.tables.map(t => ({
          id: t.id, label: t.label, seats: t.seats, type: t.type,
          is_outdoor: t.is_outdoor,
          orientation: t.orientation || "horizontal",
          status: t.status || ["free"],
          x: Number(t.position_x) || 0,
          y: Number(t.position_y) || 0,
          width: Number(t.width) || 50,
          height: Number(t.height) || 40,
        }));
        setAllTables(all);
        setTables(all.filter(t => !t.is_outdoor));
      });
  }, [selectedStr]);

  useEffect(() => {
    setTables(allTables.filter(t =>
      currentFloor === "inside" ? !t.is_outdoor : t.is_outdoor
    ));
  }, [currentFloor, allTables]);

  const updateMetrics = () => {
    const img = imgRef.current;
    if (!img) return;
    const container = img.parentElement;
    const naturalRatio = img.naturalWidth / img.naturalHeight;
    const containerRatio = container.clientWidth / container.clientHeight;
    let renderWidth, renderHeight;
    if (naturalRatio > containerRatio) {
      renderWidth = container.clientWidth;
      renderHeight = container.clientWidth / naturalRatio;
    } else {
      renderHeight = container.clientHeight;
      renderWidth = container.clientHeight * naturalRatio;
    }
    setImgScale(Math.min(renderWidth / img.naturalWidth, renderHeight / img.naturalHeight));
    setOffset({
      x: (container.clientWidth - renderWidth) / 2,
      y: (container.clientHeight - renderHeight) / 2,
    });
  };

  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col">

      {/* Header */}
      <div className="bg-gray-900 border-b border-[#c1b428] px-4 py-3 flex justify-between items-center flex-shrink-0">
        <h2 className="text-[#c1b428] font-bold text-base">Pregled stolova</h2>
        <button onClick={onClose} className="text-gray-400 text-2xl leading-none">✕</button>
      </div>

      {/* Floor switcher */}
      <div className="bg-gray-900 border-b border-gray-700 px-4 py-2 flex gap-2 flex-shrink-0">
        <button
          onClick={() => setCurrentFloor("inside")}
          className={`flex-1 py-2 rounded-lg text-sm font-bold border ${
            currentFloor === "inside"
              ? "bg-[#c1b428] text-black border-[#c1b428]"
              : "bg-gray-800 text-[#c1b428] border-gray-600"
          }`}
        >
          🏠 Unutarnji
        </button>
        <button
          onClick={() => setCurrentFloor("outside")}
          className={`flex-1 py-2 rounded-lg text-sm font-bold border ${
            currentFloor === "outside"
              ? "bg-[#c1b428] text-black border-[#c1b428]"
              : "bg-gray-800 text-[#c1b428] border-gray-600"
          }`}
        >
          🌿 Vanjski
        </button>
      </div>

      {/* Tlocrt */}
			<div 
			className="flex-1 relative overflow-hidden"
			style={{ touchAction: "none" }}
			>
			<div style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%) rotate(90deg)",
					width: "100vh",
					height: "100vw",
			}}>
					<img
					ref={imgRef}
					src={currentFloor === "inside" ? "/tlocrt_inside.png" : "/tlocrt_outside.png"}
					alt="Tlocrt"
					style={{ width: "100%", height: "100%", objectFit: "contain" }}
					onLoad={updateMetrics}
					/>
					{tables.map(table => (
					<div
							key={table.id}
							style={{
							position: "absolute",
							left: offset.x + table.x * imgScale,
							top: offset.y + table.y * imgScale,
							zIndex: 1,
							cursor: "pointer",
							}}
							onClick={() => {
							if (["moderator", "admin"].includes(user?.role)) {
									setSelectedTable(table);
							}
							}}
					>
							<TableCard table={table} imgScale={imgScale} />
					</div>
					))}
			</div>
			</div>

			{/* Legenda */}
			<div className="bg-gray-900 border-t border-gray-700 px-4 py-2 flex gap-4 text-xs text-gray-400 flex-shrink-0">
				<span>
					<span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#16a34a", marginRight: 4, verticalAlign: "middle" }} />
					Slobodan
				</span>
				<span>
					<span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#fde68a", marginRight: 4, verticalAlign: "middle" }} />
					Jutro
				</span>
				<span>
					<span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#f97316", marginRight: 4, verticalAlign: "middle" }} />
					Poslijepodne
				</span>
				<span>
					<span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#92400e", marginRight: 4, verticalAlign: "middle" }} />
					Večer
				</span>
			</div>

      {/* Modal za rezervaciju klikom na stol */}
      {selectedTable && (
        <MobileReservationModal
          tables={allTables}
          shifts={shifts}
          selectedDate={selectedDate}
          initialTable={selectedTable}
          onClose={() => setSelectedTable(null)}
          onSuccess={() => setSelectedTable(null)}
        />
      )}
    </div>
  );
};

export default FloorplanOverlay;